// logger.ts
const API_URL = "https://api.psanalytics.co.uk/ncjp/logError.php";

function sendLogToServer(level: string, message: string): void {
  const payload = {
    level: level,
    message: message,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    userAgent: navigator.userAgent
  };

  // Retrieve JWT from local storage.
  const token = localStorage.getItem("token") || "";

  // Send the log to your PHP API with the JWT in the Authorization header.
  fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Include token only if available.
      "Authorization": token ? `Bearer ${token}` : ""
    },
    body: JSON.stringify(payload)
  }).catch(err => {
    // Log failure to send error (but be cautious to avoid circular logging)
    originalConsoleWarn("Failed to log error to server:", err);
  });
}

// Preserve the original console methods so we can call them after sending logs
const originalConsoleError = console.error.bind(console);
const originalConsoleWarn = console.warn.bind(console);

// Override console.error to send log data to the server
console.error = function (...args: any[]): void {
  const message = args
    .map(arg => (typeof arg === "object" ? JSON.stringify(arg) : String(arg)))
    .join(" ");
  sendLogToServer("error", message);
  originalConsoleError(...args);
};

// Override console.warn to send log data to the server
console.warn = function (...args: any[]): void {
  const message = args
    .map(arg => (typeof arg === "object" ? JSON.stringify(arg) : String(arg)))
    .join(" ");
  sendLogToServer("warn", message);
  originalConsoleWarn(...args);
};

export {}; // Make this a module to avoid polluting global scope.
